<section class="section-div">
  <div class="header-div">
    <p class="sub-title">Work Plan Details</p>
  </div>
  <div class="content-details">
    <form action="" [formGroup]="workplan">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-md-12 col-12">
          <div class="form-rows" *ngIf="!showForm">
            <mat-label
              >Provide a detailed work plan with a time linked activity chart
            </mat-label>
            <label
              *ngIf="disName != '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input
                class="d-none"
                id="input-file-id"
                type="file"
                (change)="fileUpload($event)"
              />
            </label>
            <label
              *ngIf="disName == '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-accent"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input
                class="d-none"
                id="input-file-id"
                type="file"
                (change)="fileUpload($event)"
              />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p *ngIf="fileErrorShow == true" class="text-danger">
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                >Download & View Document</a
              >
            </div>
            <mat-error *ngIf="fileError == true">
              <span>Detailed work plan Document is required</span>
            </mat-error>
          </div>

          <div class="form-rows" *ngIf="showForm" disabled>
            <mat-label
              >provide a detailed work plan with a time linked activity
              chart</mat-label
            >
            <label
              *ngIf="disName != '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <label
              *ngIf="disName == '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-accent"
              style="cursor: not-allowed"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p
              *ngIf="
                logoCheck &&
                selecetdFile &&
                selecetdFile.size / (1024 * 1024) > maxSizeMB
              "
              class="text-danger"
            >
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                >Download & View Document</a
              >
            </div>
            <mat-error *ngIf="fileError == true">
              <span>detailed work plan Document is required</span>
            </mat-error>
          </div>
        </div>
      </div>
      <div>
        <div class="col-12 my-3 p-0">
          <h6>Target milestones <span class="text-danger">*</span></h6>
        </div>
        <table class="table">
          <thead
            style="
              padding: 18px;
              background-color: #0c0249;
              color: white;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="col">S.No</th>
              <th scope="col">Outcome</th>
              <th scope="col">Year 1</th>
              <th scope="col">Year 2</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody
            style="
              background-color: #fff;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="row" class="pt-4">1</th>
              <td class="pt-4 text-left">No. of new technologies developed</td>

              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 1 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="newTechnologyYear1"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.newTechnologyYear1?.touched &&
                        setting.newTechnologyYear1?.errors
                      "
                    >
                      <span
                        *ngIf="setting.newTechnologyYear1?.errors?.required"
                      >
                        Year 1 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 2 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="newTechnologyYear2"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.newTechnologyYear2?.touched &&
                        setting.newTechnologyYear2?.errors
                      "
                    >
                      <span
                        *ngIf="setting.newTechnologyYear2?.errors?.required"
                      >
                        Year 2 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total </mat-label>
                    <input
                      matInput
                      placeholder="Total"
                      type="text"
                      readonly
                      formControlName="newTechnologyTotalYear"
                    />
                    <mat-error
                      *ngIf="
                        setting.newTechnologyTotalYear?.touched &&
                        setting.newTechnologyTotalYear?.errors
                      "
                    >
                      <span
                        *ngIf="setting.newTechnologyTotalYear?.errors?.required"
                      >
                        Total is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">2</th>
              <td class="pt-4 text-left">
                No. of new entrepreneurs to be admitted at CoE
              </td>

              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 1 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="newEntrepreneursYear1"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.newEntrepreneursYear1?.touched &&
                        setting.newEntrepreneursYear1?.errors
                      "
                    >
                      <span
                        *ngIf="setting.newEntrepreneursYear1?.errors?.required"
                      >
                        Year 1 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 2 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="newEntrepreneursYear2"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.newEntrepreneursYear2?.touched &&
                        setting.newEntrepreneursYear2?.errors
                      "
                    >
                      <span
                        *ngIf="setting.newEntrepreneursYear2?.errors?.required"
                      >
                        Year 2 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total </mat-label>
                    <input
                      matInput
                      placeholder="Total"
                      type="text"
                      readonly
                      formControlName="newEntrepreneursTotalYear"
                    />
                    <mat-error
                      *ngIf="
                        setting.newEntrepreneursTotalYear?.touched &&
                        setting.newEntrepreneursTotalYear?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.newEntrepreneursTotalYear?.errors?.required
                        "
                      >
                        Total is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">3</th>
              <td class="pt-4 text-left">No. of products commercialized</td>

              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 1 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="productsCommercializedYear1"
                      (input)="calculateTotal3()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.productsCommercializedYear1?.touched &&
                        setting.productsCommercializedYear1?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.productsCommercializedYear1?.errors?.required
                        "
                      >
                        Year 1 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 2 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="productsCommercializedYear2"
                      (input)="calculateTotal3()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.productsCommercializedYear2?.touched &&
                        setting.productsCommercializedYear2?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.productsCommercializedYear2?.errors?.required
                        "
                      >
                        Year 2 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total</mat-label>
                    <input
                      matInput
                      placeholder="Total"
                      type="text"
                      readonly
                      formControlName="productsCommercializedTotalYear"
                    />
                    <mat-error
                      *ngIf="
                        setting.productsCommercializedTotalYear?.touched &&
                        setting.productsCommercializedTotalYear?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.productsCommercializedTotalYear?.errors
                            ?.required
                        "
                      >
                        Total is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">4</th>
              <td class="pt-4 text-left">
                No. of Training programs to be conducted
              </td>

              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 1 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="trainingProgramsYear1"
                      (input)="calculateTotal4()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.trainingProgramsYear1?.touched &&
                        setting.trainingProgramsYear1?.errors
                      "
                    >
                      <span
                        *ngIf="setting.trainingProgramsYear1?.errors?.required"
                      >
                        Year 1 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 2 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="trainingProgramsYear2"
                      (input)="calculateTotal4()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.trainingProgramsYear2?.touched &&
                        setting.trainingProgramsYear2?.errors
                      "
                    >
                      <span
                        *ngIf="setting.trainingProgramsYear2?.errors?.required"
                      >
                        Year 2 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total</mat-label>
                    <input
                      matInput
                      placeholder="Total"
                      type="text"
                      readonly
                      formControlName="trainingProgramsTotaYear"
                    />
                    <mat-error
                      *ngIf="
                        setting.trainingProgramsTotaYear?.touched &&
                        setting.trainingProgramsTotaYear?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.trainingProgramsTotaYear?.errors?.required
                        "
                      >
                        Total is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">5</th>
              <td class="pt-4 text-left">
                No. of investible startups created through CoE
              </td>

              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 1 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="investibleStartupsYear1"
                      (input)="calculateTotal5()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.investibleStartupsYear1?.touched &&
                        setting.investibleStartupsYear1?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.investibleStartupsYear1?.errors?.required
                        "
                      >
                        Year 1 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 2 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="investibleStartupsYear2"
                      (input)="calculateTotal5()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.investibleStartupsYear2?.touched &&
                        setting.investibleStartupsYear2?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.investibleStartupsYear2?.errors?.required
                        "
                      >
                        Year 2 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total</mat-label>
                    <input
                      matInput
                      placeholder="Total"
                      type="text"
                      readonly
                      formControlName="investibleStartupsTotalYear"
                    />
                    <mat-error
                      *ngIf="
                        setting.investibleStartupsTotalYear?.touched &&
                        setting.investibleStartupsTotalYear?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.investibleStartupsTotalYear?.errors?.required
                        "
                      >
                        Total is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">6</th>
              <td class="pt-4 text-left">
                No. of innovations supported with Tech transfer or IP
              </td>

              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 1 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="innovationsSupportedYear1"
                      (input)="calculateTotal6()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.innovationsSupportedYear1?.touched &&
                        setting.innovationsSupportedYear1?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.innovationsSupportedYear1?.errors?.required
                        "
                      >
                        Year 1 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Year 2 <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Number"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="innovationsSupportedYear2"
                      (input)="calculateTotal6()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                    <mat-error
                      *ngIf="
                        setting.innovationsSupportedYear2?.touched &&
                        setting.innovationsSupportedYear2?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.innovationsSupportedYear2?.errors?.required
                        "
                      >
                        Year 2 is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total</mat-label>
                    <input
                      matInput
                      placeholder="Total"
                      type="text"
                      readonly
                      formControlName="innovationsSupportedTotalYear"
                    />
                    <mat-error
                      *ngIf="
                        setting.innovationsSupportedTotalYear?.touched &&
                        setting.innovationsSupportedTotalYear?.errors
                      "
                    >
                      <span
                        *ngIf="
                          setting.innovationsSupportedTotalYear?.errors
                            ?.required
                        "
                      >
                        Total is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center mt-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn()"
          *ngIf="!showForm"
        >
          Save & Next
        </button>
      </div>
    </form>
  </div>
</section>
